<template>
  <div>
    <v-img aspect-ratio="2"
           :src="require('../../../assets/BeCool-Logo-trackpage.png')">
      <v-container container--fluid grid-list-md ref="container" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
        <v-stepper v-model="el" vertical>
          <div v-for="(st, index) in form" :key="index">
            <v-stepper-step :complete="el > index + 1"
                            :color="el > index + 1 ? 'green' : 'secondary'"
                            :step="index + 1"
                            :editable="edit || readonly"
                            :style="el === index + 1 ? 'background-color: #c4e3f1; color: white' : ''"
                            color="#0c88c2"
                            id="title-step">
              <h2>{{st.title}}</h2>
            </v-stepper-step>

            <v-stepper-content :step="index + 1" :class="{'pa-0 ma-0': $vuetify.breakpoint.smAndDown}">
              <v-card>
                <v-card-text class="header" style="line-height: 27px;">{{st.subtitle}}</v-card-text>
                <v-form v-model="validate[index]" :ref="formRef[index]">
                  <v-row align-end>
                    <v-col cols="12" md="6"
                           v-if="question.title !=='OPS Contacts' && question.title !=='Other Contacts' && question.title !=='CC Contacts'"
                           v-for="(question, indexQuestion) in st.questions" :key="10 * indexQuestion">
                      <v-card class="elevation-0">
                        <v-card-title>
                          <h3>{{question.text}}</h3>
                        </v-card-title>
                        <v-card-subtitle v-if="question.subtext">
                          <h4>{{question.subtext}}</h4>
                        </v-card-subtitle>
                        <v-card-text class="pt-2">
                          <v-row>
                            <v-col cols="10" md="8">
                              <v-text-field v-if="question.type === 'text'"
                                            v-model="renderedClient[question.model]"
                                            :rules="requiredRule"
                                            :name="renderedClient[question.model]"
                                            :readonly="readonly"
                                            :label="question.label"
                              ></v-text-field>

                              <v-textarea v-if="question.type === 'text-area'"
                                          v-model="renderedClient[question.model]"
                                          :rules="requiredRule"
                                          :readonly="readonly"
                                          :name="renderedClient[question.model]"
                                          :label="question.label"
                              ></v-textarea>

                              <v-select v-if="question.type === 'select'"
                                        v-model="renderedClient[question.model]"
                                        :menu-props="{ auto: true, overflowY: true }"
                                        :items="question.selectItems"
                                        :rules="requiredRule"
                                        :label="question.label"
                              ></v-select>

                              <div v-if="question.type === 'input'">
                                <div v-if="!clientFiles.includes(question.model)">
                                  <v-btn text outlined @click="$refs[question.inputRef][0].click()"
                                         color="blue darken-1">
                                    <div>
                                      Select Your {{question.inputRef}}
                                    </div>
                                  </v-btn>
                                  <input v-show="false" :ref="question.inputRef" type="file"
                                         @change="handleFileUpload(question.inputRef, question.model, question.format)">
                                </div>

                                <div v-else>
                                  <div v-if="question.model === 'client_logo'" class="text-center">
                                    <v-img :src="client[question.model]" width="100px"></v-img>
                                  </div>
                                  <div v-if="question.model === 'client_manifest'">
                                    <v-btn @click="convertCSVToObject" color="green" class="white--text">
                                      <v-icon class="mr-2">remove_red_eye</v-icon>
                                      CSV Preview
                                    </v-btn>
                                  </div>
                                  <div v-if="question.model === 'client_label'">
                                    <v-btn @click="displayPDF" color="green" class="white--text">
                                      <v-icon class="mr-2">remove_red_eye</v-icon>
                                      Display PDF
                                    </v-btn>
                                  </div>
                                </div>
                              </div>
                            </v-col>


                            <div v-if="question.type === 'list'">
                              <FormTable :headers="question.headers" :client="renderedClient" :regions="regions"
                                         :model="question.model" :title="question.title">
                              </FormTable>
                              <!--<ClientDetails :other-fields="false" v-if="renderedClient"-->
                              <!--:client-info="renderedClient"></ClientDetails>-->
                            </div>
                            <v-checkbox v-if="edit" color="green" v-model="$data.approvedArray"
                                        :value="question.model"></v-checkbox>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col v-else cols="12">
                      <v-row>
                        <v-col cols="12">
                          <FormTable :headers="question.headers"
                                     :client="renderedClient"
                                     :model="question.model"
                                     :title="question.title">
                          </FormTable>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row justify="center">
                    <v-btn
                      text color="blue accent-2"
                      v-if="el > 1 && !edit"
                      @click="goBack"
                    >Back
                    </v-btn>
                    <v-btn
                      text
                      v-if="!readonly && !edit"
                      :disabled="!validate[index]"
                      @click="goToNextStep"
                      :color="el === 7 ? 'indigo' : 'blue darken-1'"
                    >
                      <div v-if="el === 7">
                        Continue & go to next step
                      </div>
                      <div v-else>Continue</div>
                    </v-btn>
                  </v-row>

                  <v-card-actions class="justify-center">
                    <v-btn text v-if="el === 7 && edit" color="orange" class="white--text" @click="approveFields">
                      Approve these fields
                    </v-btn>
                    <v-btn text outlined v-if="el === 7 && !edit" color="cyan lighten-1" @click="closeApplication">
                      <v-icon class="mr-3">fas fa-paper-plane</v-icon>
                      Close Application
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-stepper-content>
          </div>

        </v-stepper>
      </v-container>
    </v-img>

    <v-dialog width="1200px" v-model="csvPreviewDialog">
      <CsvPreview :client-manifest="client_manifest" v-if="client_manifest.length > 0"></CsvPreview>
    </v-dialog>

  </div>
</template>

<script>
import FormTable from "./FormTable";
import axios from 'axios'
import CsvPreview from "./CsvPreview";
import ClientDetails from "../Clients/ClientDetails";
// @vuese
// Client application form (or client application displayer)
// @group Applications
export default {
  name: "ClientForm",
  components: {ClientDetails, CsvPreview, FormTable},
  props: {
    client: Object,
    readonly: Boolean,
    applicationKey: String,
    edit: Boolean,
    clientFiles: Array,
    clientApplications: Object,
  },
  data() {
    return {
      el: 1,
      file: '',
      emailTo: '',
      approvedArray: [],
      approvedFields: {},
      regions: [],
      validate: [false, false, false, false, false, false],
      formRef: ['form1', 'form2', 'form3', 'form4', 'form5', 'form6'],
      requiredRule: [
        v => !!v || 'This field is required'
      ],
      emailRule: [
        v => !!v || 'This field is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      phoneRule: [
        v => !!v || 'This field is required',
        v => /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(v) || 'Phone must be valid'
      ],
      form: [
        {
          title: 'Company Background',
          questions: [
            {
              text: 'Company Name',
              subtext: '(This will be used in all Client and Operational Aspects)',
              type: 'text',
              model: 'name',
              label: 'Name'
            },
            {
              text: 'Please write a short background of your company',
              subtext: null,
              type: 'text-area',
              model: 'company_background',
              label: 'Text...'
            },
            {
              text: 'Are your products fresh or frozen?',
              subtext: null,
              type: 'select',
              selectItems: ['Fresh', 'Frozen'],
              model: 'product_type',
              label: 'Type of product'
            },
            {
              text: 'What is the frequency of your delivery ?',
              subtext: null,
              type: 'select',
              selectItems: ['Weekly', 'Fortnightly', 'Monthly', 'One time only'],
              model: 'frequency',
              label: 'Frequency'
            },
            {
              text: 'Please list the anticipated volume of your deliveries per state per delivery cycle',
              subtext: null,
              type: 'list',
              headers: [
                {
                  text: 'Regions',
                  value: 'regions',
                  align: 'center',
                  rules: this.requiredRule,
                  sortable: true
                },
                {
                  text: 'Volume',
                  value: 'volume',
                  align: 'center',
                  rules: this.requiredRule,
                  sortable: true
                },
                {text: 'Actions', value: 'actions', align: 'center', sortable: false}
              ],
              title: 'Volume per region',
              model: 'anticipated_volume'
            },
            {
              text: 'Please upload an image of your logo.',
              subtext: 'For optimal viewing please upload a square logo with dimensions up to 300 x 300 in .png format',
              type: 'input',
              model: 'client_logo',
              inputRef: 'logo',
              input: 'Logo',
              format: ['jpg', 'jpeg', 'png']
            },
          ]
        },
        {
          title: 'Product Specifications',
          questions: [
            {
              text: 'Production Address',
              subtext: '(include street, suburb, postcode, state)',
              type: 'text',
              model: 'production_address',
              label: 'Address...'
            },
            {
              text: 'Production / Warehouse Contact Details',
              subtext: '(include name, email, phone number)',
              type: 'text',
              model: 'production_details',
              label: 'Text...'
            },
            {
              text: 'Packaging Type',
              subtext: null,
              type: 'select',
              selectItems: ['Polystyrene', 'Cardboard'],
              model: 'packaging',
              label: 'Type'
            },
            {
              text: 'Are there multiple box sizes ?',
              subtext: null,
              type: 'select',
              selectItems: ['Yes', 'No'],
              model: 'multiple_sizes',
              label: 'Yes or No'
            },
            {
              text: 'Please indicate the maximum size for each carton size.',
              subtext: 'Please list their dimensions w x l x h',
              type: 'text',
              model: 'dimensions',
              label: 'w x l x h'
            },
            {
              text: 'Is the weight of your largest carton under 10 KG ?',
              subtext: null,
              type: 'select',
              selectItems: ['Yes', 'No'],
              model: 'heavy_box',
              label: 'Yes or No'
            },
            {
              text: 'How many boxes fit on one pallet (approx)?',
              subtext: null,
              type: 'text',
              model: 'boxes_per_pallet',
              label: 'Number'
            },
            {
              text: 'Does your warehouse have the capability to sort boxes / pallets based on regions ?',
              subtext: null,
              type: 'select',
              selectItems: ['Yes', 'No'],
              model: 'sorting_warehouse',
              label: 'Yes or No'
            },
            {
              text: 'Please list the shelf life of your products',
              subtext: null,
              type: 'text',
              model: 'list_of_products',
              label: 'Text...'
            },
          ]
        },
        {
          title: 'Labels, and Barcodes',
          questions: [
            {
              text: 'Please indicate which column on the manifest will be utilized to generate the barcode',
              subtext: null,
              type: 'text',
              model: 'barcode_column',
              label: 'Column name'
            },
            {
              text: 'Please list the information that will be available on the label',
              subtext: '(IE. Name, customer\'s address, instructions etc)',
              type: 'text',
              model: 'label_information',
              label: 'Text...'
            },
            {
              text: 'Please upload an image of your label including the barcode',
              subtext: null,
              type: 'input',
              inputRef: 'label',
              model: 'client_label',
              format: ['jpg', 'jpeg', 'png', 'pdf']
            },
          ]
        },
        {
          title: 'IT Features',
          subtitle: 'The Be Cool Portal provides direct real time information about each individual ' +
            'delivery that is currently in our systems for delivery, as well as archival data of the' +
            ' most recent five deliveries per invoice number. The Be Cool Portal allows clients to ' +
            'acccess real-time ETAS, download PODS, and access zone information including regions and ' +
            'time slots currently being serviced.',
          questions: [
            {
              text: 'Do you want an access to the BeCool Portal?',
              subtext: null,
              type: 'select',
              selectItems: ['Yes', 'No'],
              model: 'portal_access',
              label: 'Yes or No'
            },
            {
              text: 'Is your email address domain google mail based?',
              subtext: null,
              type: 'select',
              selectItems: ['Yes', 'No'],
              model: 'google_email',
              label: 'Yes or No'
            },
            {
              text: 'Please add your email domain to access the portal',
              subtext: null,
              type: 'text',
              model: 'email_domain',
              rules: this.emailRule
            },
          ]
        },
        {
          title: 'Contact Information',
          subtitle: 'Please include as many details, and forms of communication possible. We will communicate' +
            ' primarily via email for any address / delivery queries, and via phone for any urgent matters.' +
            ' The standard Be Cool Reporting Package includes Transaction Reports sent 4 times daily, an ETA report ' +
            'sent the night prior, and any SMS replies if applicable.',
          questions: [
            {
              text: 'Please list the best contact for operational matters, including email and phone details ',
              subtext: null,
              type: 'list',
              headers: [
                {text: 'Name', value: 'name', align: 'center', rules: this.requiredRule},
                {text: 'Position', value: 'position', align: 'center', rules: this.requiredRule},
                {text: 'Email', value: 'email', align: 'center', rules: this.emailRule},
                {text: 'Phone', value: 'phone', align: 'center', rules: this.phoneRule},
                {text: 'Actions', value: 'actions', align: 'center', sortable: false}
              ],
              title: 'OPS Contacts',
              model: 'ops_contact'
            },
            {
              text: 'Please list the best contact for customer care matters, including email and phone details',
              subtext: null,
              type: 'list',
              title: 'CC Contacts',
              headers: [
                {text: 'Name', value: 'name', align: 'center', rules: this.requiredRule},
                {text: 'Position', value: 'position', align: 'center', rules: this.requiredRule},
                {text: 'Email', value: 'email', align: 'center', rules: this.emailRule},
                {text: 'Phone', value: 'phone', align: 'center', rules: this.phoneRule},
                {text: 'Actions', value: 'actions', align: 'center', sortable: false}
              ],
              model: 'cc_contact'
            },
            {
              text: 'Please list any other necessary contacts',
              subtext: null,
              type: 'list',
              title: 'Other Contacts',
              headers: [
                {text: 'Name', value: 'name', align: 'center', rules: this.requiredRule},
                {text: 'Position', value: 'position', align: 'center', rules: this.requiredRule},
                {text: 'Email', value: 'email', align: 'center', rules: this.emailRule},
                {text: 'Phone', value: 'phone', align: 'center', rules: this.phoneRule},
                {text: 'Actions', value: 'actions', align: 'center', sortable: false}
              ],
              model: 'other_contacts'
            },
            {
              text: 'Please nominate one email to receive all reports',
              subtext: 'including transaction reports, Sms Reply Reports, and ETA reports',
              type: 'text',
              model: 'ops_email',
              label: 'Email'
            },
          ]
        },
        {
          title: 'Accounting Information',
          questions: [
            {
              text: 'Legal business name:',
              subtext: null,
              type: 'text',
              model: 'legal_name',
              label: 'Name'
            },
            {
              text: 'ABN:',
              subtext: null,
              type: 'text',
              model: 'abn',
              label: 'ABN'
            },
            {
              text: 'Accounting Address:',
              subtext: null,
              type: 'text',
              model: 'accounting_address',
              label: 'Address'
            },
            {
              text: 'Accounting Contact',
              subtext: 'Including name and email and phone details',
              type: 'text',
              model: 'acc_details',
              label: 'Contact details'
            },
            {
              text: 'Payment Terms',
              subtext: null,
              type: 'select',
              model: 'payment_terms',
              selectItems: ['7 days'],
              label: 'Days'
            },
            {
              text: 'Send me a copy of my responses',
              subtext: null,
              type: 'select',
              model: 'copy_of_response',
              selectItems: ['Yes', 'No'],
              label: 'Yes or No'
            },
          ]
        },
        {
          title: 'Submit a sample manifest',
          questions: [
            {
              text: 'Please upload a sample manifest',
              subtext: null,
              type: 'input',
              inputRef: 'manifest',
              model: 'client_manifest',
              format: ['csv'],
            },
          ]
        },
      ],
      selected: {},
      client_manifest: [],
      csvPreviewDialog: false,
    }
  },
  methods: {
    // Displays client_label PDF if we are in client application preview.
    displayPDF() {
      window.open(this.client.client_label);
    },
    // Gets and displays client_manifest csv file in a table
    convertCSVToObject() {
      this.client_manifest = [];
      axios.get(this.client.client_manifest)
        .then((response) => {
          let arr = response.data;
          arr = arr.split('\n');
          let headers = arr[0].split(',');
          for (var i = 1; i < arr.length; i++) {
            let data = arr[i].split(',');
            let obj = {};
            for (var j = 0; j < data.length; j++) {
              obj[headers[j].trim()] = data[j].trim();
            }
            this.client_manifest.push(obj);
            this.csvPreviewDialog = true;
          }
          // this.client_manifest = JSON.stringify(this.client_manifest);
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
        })
    },
    // Closes client application and POST this change on API.
    closeApplication() {
      axios.post(process.env.API_URL + '/clientapplications/' + this.applicationKey + '/close', this.client)
        .then((response) => {
          // Displays snackbar and takes a message to be displayed as an argument
          this.$store.commit('displaySnackbar', 'Your application is now closed');
          this.readonly = true;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
        })
    },
    // Approve all the selected fields making an API PUT call.
    approveFields() {
      let body = {};
      body.client = this.client;
      body.approved = [];
      for (var key of this.approvedArray) {
        if (!Array.isArray(key)) {
          body.approved.push([key, this.renderedClient[key]]);
        }
      }
      axios.put(process.env.API_URL + '/clientapplications/' + this.applicationKey + '/internalcontent', body)
        .then((response) => {
          this.$store.commit('displaySnackbar', 'Fields approved ( ' + this.applicationKey + ' )');
          // Closes preview dialog of the client application and resets all relevant variables on ClientApplicationPage
          this.$emit('close');
          this.approvedArray = []
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar',  'ERROR ' + response.response.data.error);
          this.approvedArray = []
        });
    },
    // Goes to next step of the ClientForm when filling it as a new client and calling PUT endpoint to store the changes.
    goToNextStep() {
      let formRef = this.formRef[this.el - 1];
      if (this.$refs[formRef][0].validate()) {
        axios.put(process.env.API_URL + '/clientapplications/' + this.applicationKey + '/clientcontent', this.client)
          .then((response) => {
            this.el++
          })
          .catch((response) => {
            // Displays an alert when PUT /clientapplications/{application_key}/clientcontent has failed
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          });
      }
    },
    // Goes to the previous step of the ClientForm
    goBack() {
      this.el = this.el - 1;
    },
    // Handles file uploading and posts the uploaded files in the /clientapplications/{application_key}/files endpoint
    // @arg Takes the ref of the input slot used (String), the name of the field (String), an array of accepted formats for this file Array(String)
    handleFileUpload(ref, field, formatArray) {
      // this.client[field] = this.$refs[ref][0].files[0];
      let fileFormData = new FormData();
      fileFormData.set('file', this.$refs[ref][0].files[0]);
      let extension = this.$refs[ref][0].files[0].name.split('.').pop();
      if (formatArray.includes(extension)) {
        axios({
          method: 'post',
          url: process.env.API_URL + '/clientapplications/' + this.applicationKey + '/files/' + field,
          data: fileFormData,
          // config: {
          //   headers: {
          //     'Content-Type':
          //     'multipart/form-data'
          //   }
          // }
        })
          .then((response) => {
            this.$store.commit('displaySnackbar', 'File has been uploaded.');
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      } else {
        alert('Please use a file format in the following list: [' + formatArray + ']')
      }
    },
    // @vuese
    // Gets all the regions.
    getRegions() {
      axios.get(process.env.API_URL + '/clientapplications/' + this.applicationKey + '/regions')
        .then((response) => {
          this.regions = response.data;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
        })
    },
  },
  mounted() {
    if (this.edit) {
      if (Object.keys(this.client).includes('approved')) {
        for (var field of this.client.approved) {
          // this.approvedArray.push(this.values[field[0]]);
          this.approvedArray.push(field[0]);
        }
      }
    }
    if (this.edit) {
      let fileNames = ['client_logo', 'client_label', 'client_manifest'];
      for (name of fileNames) {
        this.client[name] = process.env.API_URL + '/clientapplications/' + this.applicationKey + '/files/' + name
      }
    }
    // this.getFiles();
    this.getRegions();
  },
  computed: {
    // @vuese
    // Rendered client (displaying the "approved"/"filled by the client" fields depending on where we are using ClientForm)
    renderedClient() {
      if (this.edit) {
        if (Object.keys(this.client).includes('approved')) {
          let rendered = {};
          for (var field of this.client.approved) {
            this.client.client[field[0]] = field[1]
          }
          return this.client.client
        }
      }
      return this.client
    },
    values() {
      let output = {};
      for (var key of Object.keys(this.renderedClient)) {
        output[key] = [key, this.renderedClient[key]];
        // this.values.push({field: key, value: this.renderedClient[key]});
      }
      return output
    },
  }
}
</script>

<style scoped>
.theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
  width: 200%;
  text-shadow: 0 0 0 #000;
}
.v-card__title {
  word-break: keep-all;
}
>>> #title-step .v-stepper__label {
  display: block;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/util/CreateClient/ClientForm.vue